import { render } from "./HeaderPE.vue?vue&type=template&id=15860b0c&scoped=true"
import script from "./HeaderPE.vue?vue&type=script&lang=js"
export * from "./HeaderPE.vue?vue&type=script&lang=js"

import "./HeaderPE.vue?vue&type=style&index=0&id=15860b0c&lang=less&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_6d3c9c09aad288fc51dc75b5c4e5d068/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15860b0c"]])

export default __exports__